
export default {
	mounted() {
		this.hideWriteQuestionButton();
	},
	created() {
		try {
			const yotpoApi = new Yotpo.API(yotpo)
			this.$nextTick(() => {
				yotpoApi.refreshWidgets()
			})
		} catch (err) { }
	},
	methods: {
		hideWriteQuestionButton() {
			// Only run on client side to avoid SSR issues
			if (process.client && typeof document !== 'undefined') {
				setTimeout(() => {
					const button = document.querySelector('.write-question-button');
					
					document.querySelectorAll('.yotpo-nav-tab').forEach((tab) => {
						if (tab.getAttribute('data-type') === 'questions') {
							tab.style.display = 'none';
						}
					});
					if (button) {
						button.style.display = 'none';
					}

				}, 1000); //short delay to allow the button to render
			}
		}
	}
}
